/**
 * Redux `routeHistory.routes` keys for last-visited CRM paths.
 * Values MUST stay in sync with the persistence key on each nav leaf in `crm-routes.js`
 * (`routeKey`, or `name` when `routeKey` is omitted).
 */
export const RouteLeafKey = Object.freeze({
  LEAD: "lead",
  LIST: "list",
  AUTOMATIONS: "automations",
  TEMPLATE: "template",
  DASHBOARD: "dashboard",
  REPORTS: "reports",
  SALES: "sales",
  APPOINTMENTS: "appointments",
  /** Distinct from analytics `DASHBOARD`; appointment permission name stays `"dashboard"`. */
  APPOINTMENTS_DASHBOARD: "appointments-dashboard",
});
